module.exports = __webpack_public_path__ + "89dc54bf159e59480a30ed6516dc8a52.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bird-logo-256.png
// module id = 268
// module chunks = 0